import startChat, { sendMessage } from '../services/chat';
import { api, rtm } from '../services/http';

export function setClient(response) {
  return {
    type: 'SET_CLIENT',
    response
  };
}

export function setPageError(error) {
	return {
		type: 'SET_PAGE_ERROR',
		error
	}
}

export function fetchClientSettings(store) {
	// Use a 'thunk' in order to handle async request
	return (dispatch, getState) => {
		return api.get('').then(response => {
			store.dispatch(setClient(response.data));

			if (response.data.client.chat) {
				// Initialize websockets, set Chatter
				startChat(store);
			}
		}).catch(error => {
			store.dispatch(setPageError(error));
			if (error.response.status === 503) {
				setTimeout(fetchClientSettings(store), 10000);
			}
		});
	}
}

export function setChatter(chatter) {
	return {
		type: 'SET_CHATTER',
		chatter
	}
}

export function setSocketConnected() {
	return {
		type: 'SET_SOCKET_CONNECTED'
	}
}

export function addMessage(message, messageType, data) {
	return {
		type: 'ADD_MESSAGE',
		message,
		messageType,
		data
	}
}

export function retryMessage(message) {
	return (dispatch, getState) => {
		const messageToSend = {
			body: message.body,
			by: getState().chatter.get("id"),
			data: message.data,
			type: message.type
		};

		dispatch(triggerMessageLoader());
		dispatch(lastMessageError(false));

		api.post('message/chat/', messageToSend).catch(error => {
			dispatch(lastMessageError(true));
		});
	}
}

export function lastMessageError(error) {
	return {
		type: 'LAST_MESSAGE_ERROR',
		error
	}
}

export function updateMessage(message) {
	return {
		type: 'UPDATE_MESSAGE',
		message
	}
}

export function addResponse(message) {
	return {
		type: 'ADD_RESPONSE',
		message
	}
}

export function updateResponse(message) {
	return {
		type: 'UPDATE_RESPONSE',
		message
	}
}

export function getLinkResponse(message) {
	let linkMessage = {
		id: message.id,
		body: message.title,
		linkUrl: message.url,
		type: message.type
	};

	return function(dispatch) {
		dispatch(addResponse(linkMessage));

		return rtm.get(`?url=${message.url}`)
			.then(response => {
				linkMessage.icon = response.data.icon;
				linkMessage.previewTitle = response.data.title;
				linkMessage.previewDescription = response.data.desc;

				dispatch(updateResponse(linkMessage));
			}).catch(() => {
				dispatch(updateResponse(linkMessage));
			});
	}
}

export function addMessageFromHistory(message) {
	return {
		type: 'ADD_MESSAGE_FROM_HISTORY',
		message
	}
}

export function addSuggestionsFromHistory(historyItem) {
	return {
		type: 'ADD_SUGGESTIONS_FROM_HISTORY',
		historyItem
	}
}

export function addSuggestedResponses(messages) {
	return {
		type: 'ADD_SUGGESTED_RESPONSES',
		messages
	}
}

export function deleteMessages() {
	return {
		type: 'DELETE_MESSAGES'
	}
}

export function triggerMessageLoader() {
	return {
		type: 'TRIGGER_MESSAGE_LOADER'
	}
}

export function setHasSentFirstMessage() {
	return {
		type: 'HAS_SENT_FIRST_MESSAGE'
	}
}



// WEBPACK FOOTER //
// ./src/actions/index.js